export default __webpack_public_path__ + "static/media/Fredrik-Jonsson.5f7a8d5a.jpg";